var app = angular.module('leonardo');

var ColorDirective = function(ConfigThemeService) {
  return {
    restrict: 'A',
     scope: {
      opacity: '='
    },
    link: function (scope, element, attrs) {

      scope.setColor = function () {
        if (!isNull(scope.opacity)) {
          scope.color = ConfigThemeService.getColor(attrs.color, scope.opacity);
        }
        else {
          scope.color = ConfigThemeService.config.theme_config[attrs.color] + '';
        }
        element.css('color', scope.color);
      };

      scope.setColor();

      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });

      scope.$watch(function() {
        return element.attr('color');
      }, function(newValue, oldValue){
        if ((newValue !== oldValue) && newValue) {
          scope.setColor();
        }
      });
    }
  };
};

app.directive('color', ['ConfigThemeService', ColorDirective]);
